import { render, staticRenderFns } from "./earlyWarn.vue?vue&type=template&id=352d4920&scoped=true&"
import script from "./earlyWarn.vue?vue&type=script&lang=js&"
export * from "./earlyWarn.vue?vue&type=script&lang=js&"
import style0 from "./earlyWarn.vue?vue&type=style&index=0&id=352d4920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d4920",
  null
  
)

export default component.exports